import React from 'react';
import ChevronDoubleLeft from '@elliemae/ds-icons/ChevronDoubleLeft';
import ChevronDoubleRight from '@elliemae/ds-icons/ChevronDoubleRight';
import { Grid } from '@elliemae/ds-basic/Grid';

/* eslint-disable jsx-a11y/click-events-have-key-events */
var renderMonthElement = function renderMonthElement(_ref) {
  var month = _ref.month,
      onYearSelect = _ref.onYearSelect;
  return /*#__PURE__*/React.createElement(Grid, {
    height: "20px",
    cols: ['auto', 1, 'auto'],
    alignItems: "flex-end",
    mr: "10px"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    role: "button",
    tabIndex: "0",
    onClick: function onClick() {
      return onYearSelect(month, month.year() - 1);
    }
  }, /*#__PURE__*/React.createElement(ChevronDoubleLeft, {
    width: 13.6,
    height: 13.6
  }))), /*#__PURE__*/React.createElement(Grid, null, /*#__PURE__*/React.createElement("strong", null, month.format('MMMM YYYY'))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    role: "button",
    tabIndex: "0",
    onClick: function onClick() {
      return onYearSelect(month, month.year() + 1);
    }
  }, /*#__PURE__*/React.createElement(ChevronDoubleRight, {
    width: 13.6,
    height: 13.6
  }))));
};

export { renderMonthElement };
//# sourceMappingURL=DatePickerRenderMonth.js.map
